import React, { useState, useEffect } from "react";
import ClientInfoSheet from "../components/ClientInfoSheet";
import ConversationHistory from "../components/ConversationHistory";
import EditClientModal from "../components/EditClientModal";
import FollowUpCard from "../components/FollowupCard";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const ClientDashboard = () => {
  const [open, setOpen] = useState(false);
  const [user, setUser] = useState(
    JSON.parse(localStorage.getItem("leaddetails"))
  );
  const [loading, setLoading] = useState(true);
  const [conversations, setConversations] = useState([]);
  const [agentlist, setagentlist] = useState([]);

  useEffect(() => {
    const fetchConversation = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/conversations/get-chat-list`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ lead_id: user.id }),
          }
        );
        const data = await response.json();
        setConversations(data.chat_list);
      } catch (error) {
        console.error("Error fetching conversation:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchConversation();

    axios
      .get(`${BASE_URL}/projectdetails/project/3/agents`, {
        withCredentials: true,
      })
      .then((response) => {
        setagentlist(response.data);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }, []);

  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="container mx-auto px-4 py-6">
        <ClientInfoSheet user={user} onEdit={() => setOpen(true)} />

        <div className="grid grid-cols-1 max-h-[450px] md:grid-cols-2 gap-6 max-w-6xl mx-auto ">
          <div>
            <FollowUpCard lead_id={user.id} />
          </div>
          <div>
            <ConversationHistory
              conversations={conversations}
              loading={loading}
            />
          </div>
        </div>
      </div>

      <EditClientModal
        open={open}
        onClose={() => setOpen(false)}
        lead={user}
        agentlist={agentlist}
      />
    </div>
  );
};

export default ClientDashboard;
